import { render, staticRenderFns } from "./PlaylistFavorite.vue?vue&type=template&id=0f1d41fa"
import script from "./PlaylistFavorite.vue?vue&type=script&lang=ts"
export * from "./PlaylistFavorite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports